import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { CastCalculator } from './components/CastCalculator';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="3dii530ufhy2k">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="su44jhksr2f8" />}
      <TopBar data-id="element-2" data-mp="swgmvvugvest" />
      <main data-id="element-3" data-mp="3684hdq2uasw">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="35yngfn0fdzc" />
        <StatsBand data-id="element-5" data-mp="34nbvtnbp1xo" />
        <BeforeAfter data-id="element-6" data-mp="38b66v0ldsdg" />
        <MeetingSelector data-id="element-7" data-mp="3udawg7dqol46" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="3ubriinfk2m5k" />
        <SolutionSection data-id="element-9" data-mp="d4nwrk0ubq3z" />
        <CastCalculator data-id="element-10" data-mp="d4xp3e9cy9cu" />
        <YearPlanSection data-id="element-11" data-mp="d3cwvvain2i5" />
        <MeetingsList data-id="element-12" data-mp="d2l7x3bfc30u" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-13" data-mp="85uihpdqbv2r" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-14" data-mp="864b7kq5sgc5" />
        <GuaranteeSection data-id="element-15" data-mp="3gkv17sr2xrdt" />
        <FaqSection data-id="element-16" data-mp="3gmfsn9i3ku7g" />
        <FinalCta data-id="element-17" data-mp="3glo067jsrcle" />
      </main>
      <Footer data-id="element-18" data-mp="3bmbfntgeehlz" />
      <StickyCta data-id="element-19" data-mp="3bmti57tnls2c" />
    </div>;
}